import { HIDROTEST_UYARI_KALIPLARI } from "./hidrotest.js";
import { NDT_UYARI_KALIPLARI } from "./ndt-raporu.js";
import { kimlikSade } from "./sarf.js";
/** Dönüşüm işinin belge türü (`donusum_isi.belge_turu`). PR 24'ün `boya_rapor_kaydi`'sı riserin rapor listesidir, başka ad alanı. */
export const BOYA_OKUMA_BELGE_TURU = "boya_raporu";
/** Okunan Documents türü ("Coating report (GOE)"). */
export const BOYA_OKUMA_GELEN_TURU = "boya";
export const boyaOkumaGelenTuruMu = (t) => t === BOYA_OKUMA_GELEN_TURU;
/** Olay kaydında nesne tipi (nesneId = boya_okuma_kaydi.id). */
export const BOYA_OKUMA_OLAY_NESNESI = "boya_okuma_kaydi";
/** Okunan hafif excel'in belge ailesi. Hiçbir aile sorgusu bu adı almaz (BOYA_AILESI "Coating-GOE" başka). */
export const BOYA_OKUMA_GIRDI_AILESI = "Coating-report-input";
/** DOCUMENT sayfasındaki "Document type" değeri. */
export const BOYA_OKUMA_EXCEL_ADI = "Coating report";
/** Okuma işi kodu ("COAT-7A1B2C3D"); "BY-" uyarı kodlarından ayrı. */
export const boyaOkumaKodu = (kayitId) => `COAT-${kayitId.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/** Coats tablosunda en çok satır. */
export const BOYA_KAT_EN_COK = 6;
/** DFT tablosunda en çok kolon. */
export const BOYA_DFT_EN_COK = 8;
/**
 * DOCUMENT alanları (12; sabit sıra; sözleşme §16.3, sürüm 1). Her alanın tüketicisi sözleşmede ve `boya-okuma-karsilastirma.ts`'te (`BOYA_OKUMA_OKUNAN`) yazılıdır. `etiket` hem ekran
 * metni hem DOCUMENT'teki Field adıdır. Kimlik: riser no'ları ve dört hat SN'si.
 */
export const BOYA_OKUMA_ALANLARI = [
    { alan: "form", etiket: "Form", kimlik: false },
    { alan: "riser_no", etiket: "Riser number", kimlik: true },
    { alan: "riser_no_2", etiket: "Second riser number", kimlik: true },
    { alan: "hat_sn_choke", etiket: "Choke SN", kimlik: true },
    { alan: "hat_sn_kill", etiket: "Kill SN", kimlik: true },
    { alan: "hat_sn_booster", etiket: "Booster SN", kimlik: true },
    { alan: "hat_sn_hydraulic", etiket: "Hydraulic SN", kimlik: true },
    { alan: "rapor_tarihi", etiket: "Report date", kimlik: false },
    { alan: "rapor_no_tarihi", etiket: "Date in report number", kimlik: false },
    { alan: "diger_riserler", etiket: "Other risers named", kimlik: false },
    { alan: "imza", etiket: "Report signed", kimlik: false },
    { alan: "test_bolumu", etiket: "Test section filled", kimlik: false },
];
/** Coats tablosunun alanları (satır başına 4; sabit sıra). */
export const BOYA_KAT_ALANLARI = [
    { alan: "kat", etiket: "Coat", kimlik: false },
    { alan: "urun", etiket: "Product", kimlik: false },
    { alan: "parti_a", etiket: "Batch A", kimlik: false },
    { alan: "parti_b", etiket: "Batch B", kimlik: false },
];
/** DFT tablosunun alanları (kolon başına 4; sabit sıra). En çok, sapma ve ölçüm sayısı yoktur. */
export const BOYA_DFT_ALANLARI = [
    { alan: "kolon_etiketi", etiket: "Column label", kimlik: false },
    { alan: "kolon_riser", etiket: "Riser in label", kimlik: false },
    { alan: "ortalama", etiket: "Average µm", kimlik: false },
    { alan: "en_az", etiket: "Minimum µm", kimlik: false },
];
/** Alanın ekran adı (üç listede aranır); bilinmiyorsa alanın kendisi. */
export const boyaOkumaEtiketi = (alan) => [...BOYA_OKUMA_ALANLARI, ...BOYA_KAT_ALANLARI, ...BOYA_DFT_ALANLARI].find((a) => a.alan === alan)?.etiket ?? alan;
/** ROWS başlığı (uzun biçim, iki tablo; WPS_SATIR_BASLIKLARI ile aynı biçim). */
export const BOYA_OKUMA_SATIR_BASLIKLARI = ["Table", "Row", "Field", "Value", "As written", "Page", "Certainty"];
export const BOYA_TABLOLARI = ["Coats", "DFT"];
/** Hat → DOCUMENT alanı (karşılaştırma sırası: Choke, Kill, Booster, Hydraulic). */
export const BOYA_HAT_ALANLARI = [["Choke", "hat_sn_choke"], ["Kill", "hat_sn_kill"], ["Booster", "hat_sn_booster"], ["Hydraulic", "hat_sn_hydraulic"]];
export const BOYA_FORMLARI = ["daily report", "application form"];
/** M14-6: `Form` değeri (kırpılmış, küçük harf); başka her yazım null. */
export function boyaFormOku(v) {
    const s = (v ?? "").trim().toLowerCase();
    return BOYA_FORMLARI.includes(s) ? s : null;
}
export const BOYA_KATLARI = ["primer", "intermediate", "topcoat"];
/** M14-6: `Coat` değeri (kırpılmış, küçük harf); başka her yazım null. */
export function boyaKatOku(v) {
    const s = (v ?? "").trim().toLowerCase();
    return BOYA_KATLARI.includes(s) ? s : null;
}
/** M14-6: `Report signed` ve `Test section filled` değeri (kırpılmış, küçük harf): yes | no; başka her yazım null. */
export function evetHayirOku(v) {
    const s = (v ?? "").trim().toLowerCase();
    return s === "yes" || s === "no" ? s : null;
}
/** "Also file for {b}" onayının `belge_deger_onayi.alan`'ı (parça 1'de, okuma başına bir kez). */
export const BOYA_IKINCI_ALANI = "ikinci_riser";
/** BY-07 seçiminin `belge_deger_onayi.alan`'ı (DFT kolonunun sırasıyla). */
export const boyaDftSecimAlani = (sira) => `dft_riser_${sira}`;
/** BY-07 seçiminin `yazilan`ı: "<rn>|<kolon etiketinin kimlikSade'si>". */
export const boyaDftSecimYazisi = (rn, etiket) => `${rn}|${kimlikSade(etiket)}`;
/* ---------------- riser no'ları ve yer önerisi (M14-7, M14-8) ---------------- */
const degerOf = (l, alan) => l.find((x) => x.alan === alan) ?? null;
const kesinMi = (d) => Boolean(d && d.kesinlik === "kesin" && d.deger !== null && d.deger.trim() !== "");
/** Riser no'sunun sayı kısmı, baştaki sıfırlar atılmış ("SET 0999" → "999"); rakamsızsa null (sunucunun `riserSayisi`'nin aynısı). */
export function boyaRiserSayisi(x) {
    const m = /\d+/.exec(x ?? "");
    return m ? m[0].replace(/^0+(?=\d)/, "") : null;
}
/** RN sırası: sayıya göre, eşitse metne göre. */
export const rnSirasi = (a, b) => Number(boyaRiserSayisi(a) ?? 0) - Number(boyaRiserSayisi(b) ?? 0) || (a < b ? -1 : a > b ? 1 : 0);
/** Eksik riser için bekleme adı ("997" → "R997"; 3 haneye tamamlanır). */
export const boyaBeklemeRn = (sayi) => `R${sayi.padStart(3, "0")}`;
/**
 * M14-7 (saf): kesin `riser_no` ve `riser_no_2`'nin sayıları, tekil ve artan sayı sırasıyla (sıra anlam taşımaz; en çok 2). Şüpheli riser no → `supheli` ve not `suphe`; rakamsız kesin
 * değer → not `bicim`. `bos`: iki riser no da boş (blank).
 */
export function boyaRiserleri(degerler) {
    const notlar = [];
    const sayilar = [];
    let supheli = false;
    let bos = true;
    for (const alan of ["riser_no", "riser_no_2"]) {
        const d = degerOf(degerler, alan);
        if (!d || d.kesinlik === "bos" || d.deger === null || !d.deger.trim())
            continue;
        bos = false;
        if (d.kesinlik === "suphe") {
            supheli = true;
            notlar.push({ tur: "suphe", tablo: "DOCUMENT", satir: null, alan });
            continue;
        }
        const s = boyaRiserSayisi(d.deger);
        if (!s) {
            notlar.push({ tur: "bicim", alan, deger: d.deger });
            continue;
        }
        if (!sayilar.includes(s))
            sayilar.push(s);
    }
    sayilar.sort((a, b) => Number(a) - Number(b));
    return { sayilar, supheli, bos, notlar };
}
/**
 * M14-8 (saf; NDT N13 emsali): (1) kayıtlı yer → `kisi`; (2) raporun OASIS'teki riserları (`kapsam`); yoksa SN'lerin tek riseri; yoksa riser no'su var → `riser_bekliyor`, yoksa `yok`;
 * (3) kapsamda kuyrukta olan yoksa `adim_bekliyor`; varsa kuyruktakilerin RN sırasıyla ilki önerilir. OASIS riser açmaz, riseri kuyruğa göndermez.
 */
export function boyaYerOnerisi(g) {
    const notlar = [];
    let kapsam = [...new Set(g.sayilar.map((s) => g.riserler.get(s)).filter((x) => Boolean(x)))].sort(rnSirasi);
    const eksik = g.sayilar.filter((s) => !g.riserler.has(s));
    const ciftDisi = kapsam.length && eksik.length ? eksik[0] : null;
    if (!kapsam.length) {
        const snRiserleri = [...new Set(g.snler.flatMap((s) => g.snRiseri(s)))].sort(rnSirasi);
        if (snRiserleri.length === 1) {
            kapsam = [snRiserleri[0]];
            notlar.push({ tur: "sn_riseri", rn: snRiserleri[0] });
        }
    }
    const kayitli = g.kayitli && g.kayitli.tur === "boya" ? g.kayitli : null;
    const ikinciOf = (rn) => (kapsam.includes(rn) ? kapsam.find((r) => r !== rn) ?? null : null);
    if (kayitli) {
        return { durum: "kisi", yer: { tur: "boya", rn: kayitli.rn }, neden: null, bekleme: null, kapsam, ikinci: ikinciOf(kayitli.rn), ciftDisi, notlar };
    }
    if (!kapsam.length) {
        const bos = { yer: null, kapsam: [], ikinci: null, ciftDisi: null, notlar };
        if (g.sayilar.length)
            return { ...bos, durum: "riser_bekliyor", neden: null, bekleme: { rn: boyaBeklemeRn(g.sayilar[0]) } };
        if (g.supheli)
            return { ...bos, durum: "yok", neden: "supheli", bekleme: null };
        const snRiserleri = new Set(g.snler.flatMap((s) => g.snRiseri(s)));
        return { ...bos, durum: "yok", neden: snRiserleri.size > 1 ? "sn_baska" : "bos", bekleme: null };
    }
    const kuyruktakiler = kapsam.filter((rn) => g.kuyrukta(rn));
    if (!kuyruktakiler.length)
        return { durum: "adim_bekliyor", yer: null, neden: null, bekleme: { rn: kapsam[0] }, kapsam, ikinci: null, ciftDisi, notlar };
    const rn = kuyruktakiler[0];
    return { durum: "oneri", yer: { tur: "boya", rn }, neden: null, bekleme: null, kapsam, ikinci: ikinciOf(rn), ciftDisi, notlar };
}
/** Okuma durumunun karşılığı (M14-8 `gelenDurumu`). */
export const boyaGelenDurumu = (d) => d === "kisi" || d === "oneri" ? "okundu" : d === "riser_bekliyor" ? "riser_bekliyor" : d === "adim_bekliyor" ? "adim_bekliyor" : "yer_bekliyor";
/** Kesin parti sadeleri " / " ile (yoksa ""). */
export function boyaKatAnahtari(k) {
    return ["parti_a", "parti_b"].map((a) => degerOf(k.degerler, a)).filter(kesinMi).map((d) => kimlikSade(d.deger)).join(" / ");
}
/** Kat satırları → kesin `kat`'lı satırların özeti (satır sırası). */
export function boyaKatOzetleri(katlar) {
    const sonuc = [];
    for (const s of [...katlar].sort((a, b) => a.no - b.no)) {
        const katD = degerOf(s.degerler, "kat");
        const kat = kesinMi(katD) ? boyaKatOku(katD.deger) : null;
        if (!kat)
            continue;
        const urunD = degerOf(s.degerler, "urun");
        const partiler = ["parti_a", "parti_b"].map((a) => degerOf(s.degerler, a)).filter(kesinMi);
        const parti = boyaKatAnahtari(s);
        sonuc.push({ no: s.no, kat, urunSade: kesinMi(urunD) ? kimlikSade(urunD.deger) : null, parti: parti || null, partiMetni: partiler.length ? partiler.map((d) => d.deger.trim()).join(" / ") : null, partiDegerleri: partiler });
    }
    return sonuc;
}
/** M14-10 (saf; yalnız öneri): kapsamdaki her riser için "final", "not final" ya da öneri yok. */
export function boyaFinalOnerisi(g) {
    return g.kapsam.map((rn) => {
        if (!g.tarih)
            return { rn, oneri: null, neden: "tarih_yok" };
        if (!g.topcoatVar)
            return { rn, oneri: "degil", neden: "son_kat_yok" };
        const oteki = g.digerOkumalar.filter((o) => o.riserler.includes(rn) && o.tarih && o.katlar.some((k) => k.kat === "topcoat"));
        const yeni = oteki.filter((o) => o.tarih > g.tarih).sort((a, b) => (a.tarih < b.tarih ? 1 : a.tarih > b.tarih ? -1 : 0))[0];
        if (yeni)
            return { rn, oneri: "degil", neden: "daha_yeni", kod: yeni.kod, tarih: yeni.tarih };
        const ayni = oteki.find((o) => o.tarih === g.tarih);
        if (ayni)
            return { rn, oneri: null, neden: "ayni_gun", kod: ayni.kod };
        return { rn, oneri: "final", neden: "en_yeni_son_kat" };
    });
}
/**
 * M14-17 (saf): her DFT satırı bir kolondur. (a) etiketteki riser boş → yerin riseri (`etiketsiz`); (b) etiketteki riser raporun riserlarından → o riser (`cift`); (c) dışarıda → kişinin
 * seçimi (etiket sadesi aynıysa `secildi`) ya da `secilmedi`; (d) şüpheli → `supheli`. Raporun riserları: riser no'larının sayıları, yoksa kapsamın sayıları.
 */
export function boyaDftKolonlari(g) {
    const cift = g.sayilar.length ? [...g.sayilar] : g.kapsam.map((r) => boyaRiserSayisi(r)).filter((x) => Boolean(x));
    return [...g.dftler].sort((a, b) => a.no - b.no).map((s) => {
        const etiketD = degerOf(s.degerler, "kolon_etiketi");
        const etiket = etiketD?.deger?.trim() || null;
        const riserD = degerOf(s.degerler, "kolon_riser");
        const temel = { sira: s.no, etiket, secim: null };
        if (riserD?.kesinlik === "suphe")
            return { ...temel, etiketSayisi: boyaRiserSayisi(riserD.deger), rn: null, durum: "supheli" };
        const sayi = kesinMi(riserD) ? boyaRiserSayisi(riserD.deger) : null;
        if (!sayi)
            return { ...temel, etiketSayisi: null, rn: g.yerRn, durum: "etiketsiz" };
        if (cift.includes(sayi))
            return { ...temel, etiketSayisi: sayi, rn: g.riserler.get(sayi) ?? g.yerRn, durum: "cift" };
        const secim = g.secimler.find((x) => x.sira === s.no && x.etiketSade === kimlikSade(etiket) && g.kapsam.includes(x.rn));
        if (secim)
            return { ...temel, etiketSayisi: sayi, rn: secim.rn, durum: "secildi", secim: { kim: secim.kim, ts: secim.ts } };
        return { ...temel, etiketSayisi: sayi, rn: null, durum: "secilmedi" };
    });
}
/** "Also file for {b}" engelinin okuma cümlesi (sözlükte). */
export const BOYA_IKINCI_OKUMA_DEGISTI = "The reading changed; compare again before filing it for the second riser.";
/** Saf (M14-28): kartın durumu ve yazımın ön denetimi aynı kuraldır; ilk tutan döner. `engel` yalnız "engel"de dolu. */
export function boyaIkinciDurumu(d, okumaDegistiMetni = BOYA_IKINCI_OKUMA_DEGISTI) {
    const ol = (durum, engel = null) => ({ durum, engel });
    if (d.kapali)
        return ol("kapali");
    if (!d.ikinci && !d.ciftDisi)
        return ol("yok");
    if (!d.ikinci)
        return ol("ikinci_yok");
    if (!d.okumaGuncel)
        return ol("engel", okumaDegistiMetni);
    if (d.engel)
        return ol("engel", d.engel);
    if (d.eklendi)
        return ol("eklendi");
    if (d.acik)
        return ol("dosyalanmadi");
    if (!d.kuyrukta)
        return ol("kuyrukta_degil");
    return ol("eklenebilir");
}
/* ---------------- uyarılar ---------------- */
/**
 * Kartta üretilen kodlar ve sırası (M14-24). BY-01 (K17), BY-05, BY-06 ve GEN-14 (K28) kapalıdır; KIM-03, GEN-02, GEN-10, GEN-19 bu kartta üretilmez. Hiçbiri KAPALI_UYARI_KODLARI'nda
 * olamaz (test).
 */
export const BOYA_UYARI_KODLARI = ["KIM-01", "KIM-02", "KIM-07", "KIM-08", "KIM-04", "BY-07", "BY-02", "KIM-05", "KIM-06", "GEN-18", "GEN-13", "BY-03", "BY-04", "GEN-09"];
/** Uyarı kalıpları (İngilizce anahtar; Türkçesi sözlükte). KIM ve GEN-09 öteki okuyucularınkiyle aynıdır. */
export const BOYA_UYARI_KALIPLARI = {
    "KIM-01": HIDROTEST_UYARI_KALIPLARI["KIM-01"],
    "KIM-02": HIDROTEST_UYARI_KALIPLARI["KIM-02"],
    "KIM-07": HIDROTEST_UYARI_KALIPLARI["KIM-07"],
    "KIM-08": HIDROTEST_UYARI_KALIPLARI["KIM-08"],
    "KIM-04": HIDROTEST_UYARI_KALIPLARI["KIM-04"],
    "KIM-05": HIDROTEST_UYARI_KALIPLARI["KIM-05"],
    "KIM-06": NDT_UYARI_KALIPLARI["KIM-06"],
    "GEN-09": NDT_UYARI_KALIPLARI["GEN-09"],
    "BY-07": "DFT column '{0}' names riser {1}, outside this report's pair. Choose the riser.",
    "BY-02": "DFT values do not add up: minimum is above average.",
    "BY-03": "Batch {0} differs from the earlier report for the same coat ({1}).",
    "BY-04": "Report covers risers {0} and {1}. Filed for both.",
    "GEN-18": { tarih: "The document contradicts itself: date {0} / report number {1}.", riser: "The document also names riser {0} in the description (p.{1})." },
    "GEN-13": { imza: "No signature in the report's signature block.", test: "No signature in the test section." },
};
//# sourceMappingURL=boya-okuma.js.map